import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import moment from '../../../../../lib/moment.js'
import { Header } from './header'
import Tab from './tab'
import Content from './tab-content'

export default class LOBOverviewDetail extends React.Component {
  state={ overviewTab: 1, searchResource: '' }

  toggleTab = (tab) => {
    this.setState({ overviewTab: tab })
  }

  handleChangeMonth = (month) => {
    const lobId = get(this.props, 'efficiencyResource.efficiencyResource.lob_id')
    this.props.getEfficiencyLOB(lobId, month)
  }

  exportEfficiencyLOB = () => {
    const lobId = get(this.props, 'efficiencyResource.efficiencyResource.lob_id')
    const month = moment(get(this.props, 'efficiencyResource.efficiencyResource.month')).format('YYYY-MM')
    this.props.exportEfficiencyLOB(lobId, month)
  }

  handleSearchResource = (e) => {
    this.setState({ searchResource: e })
  }

  render() {
    return (
      <Wrapper>
        <Header efficiencyResource={ get(this.props, 'efficiencyResource') } />
        <Tab
          overviewTab={ this.state.overviewTab }
          toggleTab={ this.toggleTab }
          exportEfficiencyLOB={ this.exportEfficiencyLOB }
          handleSearchResource={ this.handleSearchResource }
        />
        <Content
          overviewTab={ this.state.overviewTab }
          searchResource={ this.state.searchResource }
          efficiencyResource={ get(this.props, 'efficiencyResource') }
        />
      </Wrapper>
    )
  }
}

LOBOverviewDetail.propTypes = {
  getEfficiencyLOB: PropTypes.func,
  exportEfficiencyLOB: PropTypes.func,
}
LOBOverviewDetail.defaultProps = {
  getEfficiencyLOB: () => {},
  exportEfficiencyLOB: () => {},
}

const Wrapper = styled.div`
  background-color: #ffffff ;
  font-family: Gotham-Bold;
  font-size: 16px ;
  height: 80px ;
  width: 100%;
`




// WEBPACK FOOTER //
// ./src/components/efficiency-resource/tab-content/lob-overview/detail/index.js